export enum CABIN_CLASSES {
  economy = 'Y',
  business = 'C',
}

export enum CABIN_CLASSES_FULL {
  Y = 'economy',
  C = 'business',
}
